var variables = require(process.env.themeFolder);

require([
    'jquery',
    'swiper'
],
function($, SwiperModule) {
    var Swiper = SwiperModule.default || SwiperModule;
    var Navigation = SwiperModule.Navigation;
    
    if (Swiper.use) {
        Swiper.use([Navigation]);
    }
    
    $(document).ready(function () {
        initializeProductSlider();
        initializeUpsellSlider();
        initializeCrosssellSlider();
        initializeRelatedSlider();
        
        window.sliders = [
            {wrapperClass: '.related .products-grid', swiper: window.relatedProductsSlider},
            {wrapperClass: '.crosssell .products-grid', swiper: window.crosssellSlider},
            {wrapperClass: '.upsell .products-grid', swiper: window.upsellSlider},
            {wrapperClass: '.product-slider .products-list, .product-slider .products-grid', swiper: window.mainSlider}
        ];

        Object.keys(window.sliders).forEach(function(key){
            lazyloadSwiperImages(window.sliders[key].swiper, window.sliders[key].wrapperClass);
        });
    });
    
    function initializeProductSlider() {
        $('.product-slider .product-items').before('<div class="swiper-button-prev"></div>').after('<div class="swiper-button-next"></div>');
        $('.products-list, .products-grid').addClass('swiper-transition');

        window.mainSlider = new Swiper('.product-slider .products-list, .product-slider .products-grid', {
            containerModifierClass: 'products-grid, product-items',
            wrapperClass: 'product-items',
            slideClass: 'product-item',
            loop: variables.mainSlideLoop,
            loopedSlides: 10,
            slidesPerView: variables.mainSlidesXs,
            slidesPerColumn: 1,
            spaceBetween: variables.mainSlidesSpaceBetweenSmall,
            observer: true,
            observeParents: true,
            breakpointsInverse: true,
            breakpoints: {
                [variables.xs]: {
                    slidesPerView: variables.mainSlidesXs,
                    spaceBetween: variables.mainSlidesSpaceBetweenSmall,
                },
                [variables.sm]: {
                    slidesPerView: variables.mainSlidesSm,
                    spaceBetween: variables.mainSlidesSpaceBetween,
                },
                [variables.md]: {
                    slidesPerView: variables.mainSlidesMd,
                    spaceBetween: variables.mainSlidesSpaceBetween,
                },
                [variables.lg]: {
                    slidesPerView: variables.mainSlidesLg,
                    spaceBetween: variables.mainSlidesSpaceBetween,
                },
                [variables.xl]: {
                    slidesPerView: variables.mainSlidesXl,
                    spaceBetween: variables.mainSlidesSpaceBetween,
                }
            },
            navigation: {
                nextEl: '.product-slider .swiper-button-next',
                prevEl: '.product-slider .swiper-button-prev'
            },
            pagination: {
                el: '.swiper-pagination'
            }
        });
    }
    
    function initializeUpsellSlider() {
        $('.upsell .product-items').before('<div class="swiper-button-prev"></div>').after('<div class="swiper-button-next"></div>');
        $('.products-grid').addClass('swiper-transition');

        window.upsellSlider = new Swiper('.upsell .products-grid', {
            containerModifierClass: 'products-grid',
            wrapperClass: 'product-items',
            slideClass: 'product-item',
            loop: variables.upsellLoop,
            slidesPerView: variables.upsellSlidesXs,
            slidesPerColumn: 1,
            spaceBetween: variables.upsellSlidesSpaceBetween,
            observer: true,
            observeParents: true,
            breakpointsInverse: true,
            breakpoints: {
                [variables.xs]: {
                    slidesPerView: variables.upsellSlidesXs,
                },
                [variables.sm]: {
                    slidesPerView: variables.upsellSlidesSm,
                },
                [variables.md]: {
                    slidesPerView: variables.upsellSlidesMd,
                },
                [variables.lg]: {
                    slidesPerView: variables.upsellSlidesLg,
                },
                [variables.xl]: {
                    slidesPerView: variables.upsellSlidesXl,
                }
            },
            navigation: {
                nextEl: '.upsell .swiper-button-next, .crosssell .swiper-button-next',
                prevEl: '.upsell .swiper-button-prev, .crosssell .swiper-button-prev'
            },
            pagination: {
                el: '.swiper-pagination'
            }
        });
    }
    
    function initializeCrosssellSlider() {
        $('.crosssell .product-items').before('<div class="swiper-button-prev"></div>').after('<div class="swiper-button-next"></div>');
        $('.products-grid').addClass('swiper-transition');

        window.crosssellSlider = new Swiper('.crosssell .products-grid', {
            containerModifierClass: 'products-grid',
            wrapperClass: 'product-items',
            slideClass: 'product-item',
            loop: variables.crossellLoop,
            slidesPerView: variables.crossellSlidesXs,
            slidesPerColumn: 1,
            spaceBetween: variables.crossellSlidesSpaceBetween,
            observer: true,
            observeParents: true,
            breakpointsInverse: true,
            breakpoints: {
                [variables.xs]: {
                    slidesPerView: variables.crossellSlidesXs,
                },
                [variables.sm]: {
                    slidesPerView: variables.crossellSlidesSm,
                },
                [variables.md]: {
                    slidesPerView: variables.crossellSlidesMd,
                },
                [variables.lg]: {
                    slidesPerView: variables.crossellSlidesLg,
                },
                [variables.xl]: {
                    slidesPerView: variables.crossellSlidesXl,
                }
            },
            navigation: {
                nextEl: '.upsell .swiper-button-next, .crosssell .swiper-button-next',
                prevEl: '.upsell .swiper-button-prev, .crosssell .swiper-button-prev'
            },
            pagination: {
                el: '.swiper-pagination'
            }
        });
    }
    
    function initializeRelatedSlider() {
        $('.related .product-items').before('<div class="swiper-button-prev"></div>').after('<div class="swiper-button-next"></div>');
        $('.products-grid').addClass('swiper-transition');

        window.relatedProductsSlider = new Swiper('.related .products-grid', {
            containerModifierClass: 'products-grid',
            wrapperClass: 'product-items',
            slideClass: 'product-item',
            loop: variables.relatedLoop,
            slidesPerView: variables.relatedSlidesXs,
            slidesPerColumn: 1,
            spaceBetween: variables.relatedSlidesSpaceBetween,
            observer: true,
            observeParents: true,
            breakpointsInverse: true,
            breakpoints: {
                [variables.xs]: {
                    slidesPerView: variables.relatedSlidesXs,
                },
                [variables.sm]: {
                    slidesPerView: variables.relatedSlidesSm,
                },
                [variables.md]: {
                    slidesPerView: variables.relatedSlidesMd,
                },
                [variables.lg]: {
                    slidesPerView: variables.relatedSlidesLg,
                },
                [variables.xl]: {
                    slidesPerView: variables.relatedSlidesXl,
                }
            },
            navigation: {
                nextEl: '.related .swiper-button-next',
                prevEl: '.related .swiper-button-prev'
            },
            pagination: {
                el: '.swiper-pagination'
            }
        });
    }

    function lazyloadSwiperImages(swiperSlider, wrapperClass) {
        if (!swiperSlider) return;
        
        try {
            swiperSlider.on('slideChange', function () {
                var $img = $(wrapperClass).find('.product-item img, .product-item source');
                showImage($img);
            });
        } catch (e) {
            console.warn('Error setting up lazy loading for', wrapperClass);
        }
    }

    function showImage($img) {
        $img.each(function(){
            var $element = $(this);
            var src = $element.data('original');
            var srcset = $element.data('originalset');
            
            if (src) {
                $element.attr('src', src);
            }
            
            if (srcset) {
                $element.attr('srcset', srcset).addClass('loaded');
            }
        });
    }
});
